import React from "react";

interface Tier {
  name: string;
  price: string;
  highlight?: boolean;
  features: string[];
}

const tiers: Tier[] = [
  {
    name: "Free",
    price: "$0",
    features: [
      "Basic asset & campaign management",
      "Up to 3 campaigns",
      "Up to 50 assets",
      "Up to 10 characters",
    ],
  },
  {
    name: "Pro",
    price: "$10/mo",
    highlight: true,
    features: ["Unlimited campaigns", "Unlimited assets", "Unlimited characters", "Advanced tools"],
  },
  {
    name: "Creator",
    price: "$20/mo",
    features: ["Everything in Pro", "Sell on the Marketplace"],
  },
  {
    name: "Team",
    price: "$50/mo",
    features: ["Everything in Creator", "Group access for your table"],
  },
];

const PricingPage: React.FC = () => {
  return (
    <div className="bg-zinc-950 text-white min-h-screen p-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl font-light tracking-wide mb-2">Pricing</h1>
        <p className="text-zinc-400 mb-8">
          Choose the plan that fits your table. Payments coming soon.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {tiers.map((tier) => (
            <div
              key={tier.name}
              className={`bg-zinc-900 border p-6 flex flex-col ${
                tier.highlight ? "border-amber-400" : "border-zinc-800"
              }`}
            >
              <h2 className="text-xl font-semibold text-amber-400 tracking-wide">{tier.name}</h2>
              <p className="text-2xl font-light mt-2 mb-6">{tier.price}</p>
              <ul className="space-y-2 text-sm text-zinc-300 flex-1">
                {tier.features.map((feature) => (
                  <li key={feature} className="flex gap-2">
                    <span className="text-amber-400">•</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingPage;
